// extracted by mini-css-extract-plugin
module.exports = {"containerBank":"styles_containerBank__1ZO5w","containerModule":"styles_containerModule__nIARY","date":"styles_date__3Lcwp"};